import { Role } from './role';

// User DTO
export interface User {
  id: string;
  tenantId: string | null;
  email: string;
  firstName: string;
  lastName: string;
  fullName: string;
  roleId: string;
  role: Role;
  isActive: boolean;
  isSystemAdmin: boolean;
  lastLoginAt: string | null;
  createdAt: string;
  updatedAt: string | null;
}

// User List Item (for table views)
export interface UserListItem {
  id: string;
  tenantId: string | null;
  email: string;
  firstName: string;
  lastName: string;
  fullName: string;
  roleName: string;
  isActive: boolean;
  isSystemAdmin: boolean;
  lastLoginAt: string | null;
  createdAt: string;
}

// System User (admin users without tenant)
export interface SystemUser extends User {
  tenantId: null;
  isSystemAdmin: true;
}

// Team Member (users within a tenant)
export interface TeamMember {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  fullName: string;
  roleId: string;
  roleName: string;
  isActive: boolean;
  lastLoginAt: string | null;
  createdAt: string;
}

// Create User Request (for system users)
export interface CreateUserRequest {
  email: string;
  password: string;
  firstName: string;
  lastName: string;
  roleId: string;
}

// Update User Request
export interface UpdateUserRequest {
  firstName?: string;
  lastName?: string;
  isActive?: boolean;
}

// Create Team Member Request
export interface CreateTeamMemberRequest {
  email: string;
  password: string;
  firstName: string;
  lastName: string;
  roleId: string;
}

// Update Team Member Request
export interface UpdateTeamMemberRequest {
  firstName?: string;
  lastName?: string;
  isActive?: boolean;
}

// Update Team Member Role Request
export interface UpdateTeamMemberRoleRequest {
  roleId: string;
}

// Change Password Request
export interface ChangePasswordRequest {
  currentPassword: string;
  newPassword: string;
}

// API Response wrapper
export interface ApiResponse<T> {
  success: boolean;
  message: string | null;
  data: T;
}

// User status helpers
export const getUserStatusLabel = (isActive: boolean): string => {
  return isActive ? 'Aktif' : 'Pasif';
};

export const getUserStatusColor = (isActive: boolean): string => {
  return isActive ? 'success' : 'error';
};

// Format last login
export const formatLastLogin = (lastLoginAt: string | null): string => {
  if (!lastLoginAt) return 'Hiç giriş yapmadı';

  const date = new Date(lastLoginAt);
  const now = new Date();
  const diffMs = now.getTime() - date.getTime();
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

  if (diffDays === 0) return 'Bugün';
  if (diffDays === 1) return 'Dün';
  if (diffDays < 7) return `${diffDays} gün önce`;
  if (diffDays < 30) return `${Math.floor(diffDays / 7)} hafta önce`;
  return date.toLocaleDateString('tr-TR');
};
